import React from 'react';
import PropTypes from 'prop-types';

const AccessViewDefaultAlert = ({ resetDefaultBranch }) => {
    if (!resetDefaultBranch) {
        return null;
    }

    return (
        <p className="text-danger">
            You no longer have access to the branch you previously selected as your default. Please set a new default
            branch.
        </p>
    );
};

AccessViewDefaultAlert.propTypes = {
    resetDefaultBranch: PropTypes.bool,
};

AccessViewDefaultAlert.defaultProps = {
    resetDefaultBranch: false,
};

export default AccessViewDefaultAlert;
